import styled from "styled-components";
import { black, gray, grayDark } from "../styles/colors";
import { ScrollReveal } from "./ScrollReveal";

export function FeaturesIntro() {
  return (
    <Section id="features">
      <ScrollReveal>
        <Eyebrow>Features</Eyebrow>
        <Title>Everything you need to document real growth</Title>
        <Subtitle>
          Progress is built around one idea: showing up matters. These are the
          tools that help you capture it, organize it, and share it.
        </Subtitle>
      </ScrollReveal>
    </Section>
  );
}

const Section = styled.section({
  padding: "96px 24px 24px",
  maxWidth: 720,
  margin: "0 auto",
  textAlign: "center",
});

const Eyebrow = styled.p({
  margin: "0 0 12px",
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: gray,
});

const Title = styled.h2({
  margin: "0 0 16px",
  fontSize: "clamp(32px, 4vw, 44px)",
  fontWeight: 700,
  letterSpacing: "-0.03em",
  color: black,
});

const Subtitle = styled.p({
  margin: 0,
  fontSize: 18,
  lineHeight: 1.7,
  color: grayDark,
});
